<template>
  <div>
    <v-card
      rounded="lg"
      elevation="2"
      :height="isStaff ? 310 : 330"
      :width="220"
      class="fill-height overflow-hidden"
      :class="!isStaff ? 'clickable': ''"
      @click="!isStaff ? $router.push({ name: $routeNames.PLAYER_DETAILS, params: { id: player.id } }) : undefined"
    >
      <div style="height: 310px; position: relative">
        <v-img
          height="220"
          width="220"
          :src="player.photo_url"
          class="position-relative"
        >
          <template v-slot:default>
            <v-row
              class="flex-column fill-height"
              justify="end"
              no-gutters
            >
              <v-col
                cols="auto"
                align-self="start"
              >
                <v-sheet
                  v-if="player.jersey_number"
                  class="d-inline-flex align-center justify-center rounded-circle ma-2"
                  height="30"
                  width="30"
                  color="primary darken-2"
                >
                  <span
                    class="white--text font-weight-bold text-h6"
                  >{{ player.jersey_number }}</span>
                </v-sheet>
              </v-col>
            </v-row>
          </template>
          <template v-slot:placeholder>
            <v-row
              no-gutters
              align="center"
              justify="center"
              class="fill-height"
            >
              <v-col cols="auto">
                <v-icon large>
                  far fa-user
                </v-icon>
              </v-col>
            </v-row>
          </template>
        </v-img>
        <v-divider />
        <div
          v-if="!isStaff"
          class="py-2 grey--text text--darken-2 col"
        >
          <v-row
            no-gutters
            justify="space-between"
          >
            <v-col
              cols="9"
              class="font-weight-bold"
              style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
            >
              {{ player.first_name }} {{ player.last_name }}
            </v-col>
            <v-col
              cols="auto"
            >
              <v-chip
                v-if="player.player_positions[0]"
                x-small
                label
              >
                {{ player.player_positions[0].short_name }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row
            class="caption mt-2"
            no-gutters
            justify="space-between"
          >
            <v-col
              cols="auto"
              class="font-weight-bold"
            >
              {{ $t("individual_analysis.data.age") }}
            </v-col>
            <v-col cols="auto">
              {{ playerAge }}
            </v-col>
          </v-row>
          <v-row
            class="caption mt-2"
            no-gutters
            justify="space-between"
          >
            <v-col
              cols="auto"
              class="font-weight-bold"
            >
              {{ $t("player_card.height_weight.label") }}
            </v-col>
            <v-col cols="auto">
              {{ player.height ? player.height : '- ' }}{{ 'cm/' }}{{ player.weight ? convertWeightByTimezone(player.weight, user.organisation_settings.timezone, true) : ' - ' }}{{ weightSuffix(user.organisation_settings.timezone) }}
            </v-col>
          </v-row>
          <v-row
            class="caption mt-2"
            no-gutters
            justify="space-between"
          >
            <v-col
              cols="auto"
              class="font-weight-bold"
            >
              {{ $t("player_card.status.label") }}
            </v-col>
            <v-col
              v-if="player.player_status"
              cols="auto"
            >
              <v-chip
                x-small
                :color="player.player_status.name === 'healthy' ? 'success' : 'error lighten-3'"
                dark
                label
              >
                {{ $t(`player_status.${player.player_status.name}`) }}
              </v-chip>
            </v-col>
          </v-row>
        </div>
        <div
          v-else
          class="py-2 grey--text text--darken-2 col"
        >
          <v-row
            no-gutters
            justify="space-between"
          >
            <v-col
              class="font-weight-bold"
              style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
            >
              {{ player.first_name }} {{ player.last_name }}
            </v-col>
          </v-row>
          <v-row
            class="caption mt-2"
            no-gutters
            justify="space-between"
          >
            <v-col
              cols="auto"
              class="font-weight-bold"
            >
              {{ $t("player_card.type.label") }}
            </v-col>
            <v-col cols="auto">
              {{ $t(`coach_type.${toCamelCase(player.coach_type.name )}`) }}
            </v-col>
          </v-row>
          <v-row
            class="caption mt-2"
            no-gutters
            justify="space-between"
          >
            <v-col
              cols="auto"
              class="font-weight-bold"
            >
              {{ $t("player_card.age.label") }}
            </v-col>
            <v-col cols="auto">
              {{ playerAge }}
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { convertWeightByTimezone, weightSuffix } from '@/components/training-builder/helpers'
import { toCamelCase } from '@/utils/helpers'

export default {
  name: 'PlayerCard',
  components: { },
  props: {
    player: {
      type: Object,
      required: true
    },
    isStaff: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mediaDialog: false,
      flipped: false
    }
  },
  computed: {
    playerAge() {
      if (!this.player.birth_date) return ''

      return this.$dayjs().diff(this.$dayjs(this.player.birth_date), 'year')
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    }
  },
  methods: { toCamelCase, weightSuffix, convertWeightByTimezone, dayjs }
}
</script>
